<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading">
  <mat-card appearance="outlined">
    <form (ngSubmit)="submit()">

      <mat-form-field *ngIf="isCreateDialog && !screenName">
        <input [(ngModel)]="redirect.screenUUID"
               matInput
               name="screen"
               placeholder="Screen UUID"
               required>
      </mat-form-field>

      <mat-form-field *ngIf="!isCreateDialog || screenName">
        <input [(ngModel)]="screenName"
               [disabled]=true
               matInput
               name="screen"
               placeholder="Screen"
               required>
      </mat-form-field>

      <mat-form-field>
        <input [(ngModel)]="redirect.title"
               matInput
               name="title"
               placeholder="title"
               required>
      </mat-form-field>

      <mat-form-field class="textarea">
        <textarea
          [(ngModel)]="description"
          mat-maxlength="150"
          matInput
          name="description"
          placeholder="Add a Description to the redirect."></textarea>
      </mat-form-field>

      <div class="row">
        <mat-form-field>
          <input [(ngModel)]="lat"
                 matInput
                 name="latitude"
                 placeholder="Latitude">
        </mat-form-field>
        <mat-form-field>
          <input [(ngModel)]="long"
                 matInput
                 name="longitude"
                 placeholder="Longitude">
        </mat-form-field>
      </div>
      <div class="row">
        <button color="primary"
                mat-raised-button
                type="submit">
          Save
        </button>
      </div>
    </form>
  </mat-card>
</page-content>
